import React from "react";
import { Link } from "react-router-dom";

// Mobile-only "Loop In" bar.
//
// On a phone the download CTA sits at the very bottom of a long page, so the
// action the whole story builds toward is only reachable after a full scroll.
// Desktop does not have that problem: the hero CTA stays near the viewport and
// the page is far shorter in screens, so this is `md:hidden` rather than a
// global sticky bar.
//
// Brand blue ground with coral type. The blue was chosen by MEASURING contrast
// against coral, not by eye: the brighter, more appealing blues (#2B5BD7 at
// 2.95:1, #2F6BE0 at 2.46:1) both fail against #FFA07A, while #1e45a8 reads
// 4.27:1 and clears AA for an 18px bold label.
//
// Both colours are written as literals rather than tokens: this pill floats
// over every section, including the coral and teal ones, so it must not be
// remapped by the theme, and its contrast has to hold wherever it lands.
//
// It links to the #get-the-app anchor on the closing section rather than to
// /download, so it completes the story on the same page instead of bouncing the
// reader out of it.
//
// Sized to its label and centred, not full width: a full-bleed bar reads as
// app chrome and walls off the bottom of the page. A pill floats over the
// content it belongs to.
//
// safe-area-inset-bottom keeps it clear of the iOS home indicator.

const JoinBar: React.FC = () => (
  // Deliberately touches NEITHER the bottom edge nor the side edges.
  //
  // It was `inset-x-0 bottom-0`: full width, flush to the bottom. iOS Safari
  // treats a full-width element pinned to the bottom edge as a docked bar and
  // stops rendering its own toolbar translucent, which is why the home page had
  // a solid bottom bar while every other page was fine. This is the only page
  // with a fixed bottom overlay, and that was the tell.
  //
  // So the element is centred at its content width, and offset UP from the edge
  // via `bottom` rather than padded down to it. Safari then has clear viewport
  // edges either side and below, and goes back to blurring the page behind it.
  //
  // SHADOW REACH vs CLEARANCE. The shadow is sized against the gap beneath the
  // pill, not chosen for looks. The previous pair reached 16+40 = 56px below it
  // with only 12px of clearance, so roughly 44px was cut off by the bottom of
  // the screen, which is what read as a clipped shadow. Now 8+18 = 26px of
  // reach against 20px plus the device safe-area inset (34px on a modern
  // iPhone), so it lands well inside the viewport.
  <div
    className="md:hidden fixed left-1/2 -translate-x-1/2 z-50 pointer-events-none"
    style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom, 0px))" }}
  >
    <Link
      to="/download"
      className="pointer-events-auto inline-flex items-center justify-center h-14 px-9 rounded-full font-bold text-lg tracking-[-0.01em] whitespace-nowrap shadow-[0_3px_8px_rgba(30,69,168,0.24),0_8px_18px_rgba(30,69,168,0.16)] active:translate-y-px transition-transform"
      style={{ backgroundColor: "#1e45a8", color: "#ffa07a" }}
    >
      Loop In
    </Link>
  </div>
);

export default JoinBar;
